<script lang="ts">
	import EmeterAdvancedView from 'src/components/Sidepanel/DeviceViews/Emeter/EmeterAdvancedView.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;
</script>

<!-- For now we only use the advanced view for emeter devices. However the logic for view change remains, if we need to use it, for future changes. -->
<EmeterAdvancedView {device} />
